<template>
    <div class="m-portlet m-portlet--head-sm">
        <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                    <h3 class="m-portlet__head-text">
                        购物车未结算
                    </h3>
                </div>
            </div>
        </div>

        <div class="m-portlet__body infinite-list-wrapper">
            <div class="m-widget4" v-infinite-scroll="load"
                 infinite-scroll-disabled="disabled">
                <div class="m-widget4__item"
                     v-for="item in _.orderBy($parentInfo.Task_StudentCart.data, 'cart_id','desc')" :key="item.id"
                     @click="GoToStudent(item)">
                    <div class="m-widget4__info">
                        <span class="m-widget4__title">
                            {{item.name}}
                        </span><br>
                        <span class="m-widget4__sub">
                            {{item.school_name}}/{{item.grade_name}}
                        </span>
                    </div>
                    <span class="m-widget4__ext">
                        <span class="m-widget4__number m--font-brand">¥{{parseFloat(item.sum_price).toFixed(2)}}</span>
                    </span>
                </div>
            </div>
            <p v-if="loading">加载中...</p>
            <p v-if="noMore">没有更多了</p>
        </div>

    </div>

</template>

<script>
    export default {
        name: "Task_StudentCart",
        data() {
            return {
                currentPageSize: 10,
                currentPage: 1,
                count: 10,
                loading: false,
                waiting: false,
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.$wApi.addListen(this.$parentInfo.path, this.handleData);
        },
        computed: {
            noMore() {
                return this.count === 0
            },
            disabled() {
                return this.loading || this.noMore
            }
        },
        methods: {
            handleData(event, data) {
                switch (event) {
                    case 'init_studentCart':
                        this.count = data.total;
                        this.waiting = false;
                        this.loading = false;
                        break;
                }
            },
            load() {
                if(this.$parentInfo.task_scroll) {
                    this.loading = true;
                    if (!this.waiting) {
                        this.currentPage++;
                        this.waiting = true;
                        this.$wApi.send(this.$parentInfo.path, 'init_studentCart', {
                            'currentPageSize': this.currentPageSize,
                            'currentPage': this.currentPage,
                            'semester_id':this.$parentInfo.filter.semester_id
                        });
                    }
                }

            },
            GoToStudent(item) {
                this.$store.dispatch('addView', {
                    'title': item.name,
                    'path': '/student/' + item.id,
                    'closable': true
                });
                this.router.push({path: '/student/' + item.id})
            },
        }
    }
</script>

<style scoped>
    .infinite-list-wrapper {
        height: 300px;
        overflow: auto;
    }
</style>
